import { ChakraV3 } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { Link } from 'react-router-dom';

interface Props extends ChakraV3.ErrorProps {
  type: 'Unauthorized' | 'Forbidden' | 'NotFound';
}

export const PageError = (props: Props) => {
  const { type, ...rest } = props;

  const extra = (
    <ChakraV3.HStack>
      <ChakraV3.Button colorPalette='brand' onClick={() => history.go()}>
        Reload
      </ChakraV3.Button>
      <Link to={'/'}>
        <ChakraV3.Button variant='subtle'>Go back</ChakraV3.Button>
      </Link>
    </ChakraV3.HStack>
  );

  const { title, description } = P.run(() => {
    switch (type) {
      case 'Unauthorized':
      case 'Forbidden':
        return {
          title: 'Unauthorized',
          description: 'You are not authorized to access this page',
        };
      case 'NotFound':
        return {
          title: 'Not Found',
          description: 'We could not find the page you were looking for',
        };
    }
  });

  return <ChakraV3.Error title={title} description={description} extra={extra} {...rest} />;
};
